import { CommonModule } from "@angular/common";
import { AfterViewChecked, Component, inject, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Server } from "@jack-sparrow-libraries/emotion-models";
import { AppState, selectCurrentIdel, ServerService } from "features";
import { environment } from "@env/environment";
import { EfactureAuthService } from "@jack-sparrow-libraries/facture-electronique";
import { AgatheYouCareService } from "@services/agathe-you-care.service";
import { AgatheYouCareAssets } from "@core/constantes/agathe-you-care.constant";

@Component({
	selector: "app-disconnect-page",
	templateUrl: "./disconnect-page.component.html",
	styleUrls: ["./disconnect-page.component.scss"],
	standalone: true,
	imports: [CommonModule],
})
export class DisconnectPageComponent implements OnInit, AfterViewChecked {
	private readonly store = inject(Store<AppState>);
	private readonly efactureAuthService = inject(EfactureAuthService);
	private readonly agatheYouCareService = inject(AgatheYouCareService);
	// private readonly strutsService =  inject(StrutsService);

	private delay = 5000;
	public readonly $client = this.store.selectSignal(selectCurrentIdel);
	protected readonly $isCare = this.agatheYouCareService.$isCare;
	protected readonly AgatheYouCareAssets = AgatheYouCareAssets;

	/**
	 * Filet de securite pour les deconnexions QUE Struts declenche (menu Struts, expiration
	 * d'inactivite) : elles n'entrent pas par le menu profil de cette app, mais atterrissent
	 * ici. Le cookie `cba-auth` du back efacture doit etre efface avant la redirection SSO,
	 * sinon la session e-facturation survit au logout (l'utilisateur suivant sur ce navigateur
	 * accederait aux factures du precedent).
	 *
	 * Dans `ngOnInit` et non `ngAfterViewChecked` : ce dernier s'execute a chaque cycle de
	 * detection, il emettrait autant de requetes. L'appel est idempotent cote back (200 meme
	 * sans session), et il reste 5 s avant la redirection.
	 */
	ngOnInit(): void {
		this.efactureAuthService.logout().subscribe({ error: () => undefined });
	}

	// obligé de passer par AfterViewChecked car le timer n'est pas réinitialisé
	// en cas de navigation back dans le constructeur ou ngOnInit
	ngAfterViewChecked(): void {
		this.logout();
	}

	public logout(): void {
		// reset le timer
		//this.sessionService.resetUserActivityTimer();

		// définit l'url de déconnexion SSO en fonction du serveur
		const baseUrl = window.location.origin;
		let baseUrlSso = "";

		switch (ServerService.getServer()) {
			case Server.PROD:
				baseUrlSso = "https://moncompte.cbainfo.fr/oauth/v2/auth/logout";
				break;
			case Server.PREPROD:
				baseUrlSso = "https://preprod-sso.cbainfo.fr/oauth/v2/auth/logout";
				break;
			case Server.DEV:
				if (environment.api().includes("preprod")) {
					baseUrlSso = "https://preprod-sso.cbainfo.fr/oauth/v2/auth/logout";
				} else if (environment.api().includes("frontend")) {
					baseUrlSso = "https://sso.qualif.cbainfo.fr/oauth/v2/auth/logout";
				}
				break;
			default:
				baseUrlSso = "https://sso.qualif.cbainfo.fr/oauth/v2/auth/logout";
				break;
		}

		// construit l'url de déconnexion SSO
		const urlDeconnexionSso = baseUrlSso + "?redirect_uri=" + baseUrl;

		// détruit la session struts
		// this.strutsService.dispatch({
		// 	action: StrutsActionType.DESTROY_SESSION,
		// });

		// redirige vers la page de déconnexion SSO après {{delay}} secondes
		setTimeout(() => {
			window.open(urlDeconnexionSso, "_self"); // redirige vers la page de déconnexion SSO
		}, this.delay);
	}
}
